import React, { FunctionComponent } from 'react';
import { Challenge } from "/src/domain/challenges/ChallengeProtocolData";
import makeStyles from '@mui/styles/makeStyles';
import { getChallengeDate } from "/src/domain/shared/getChallengeDate";
import { useTranslation } from 'react-i18next';


interface ChallengeBlockData {
    challenge: Challenge
}

const ChallengeHeader: FunctionComponent<ChallengeBlockData> = ({challenge}) => {
    const {t} = useTranslation()
    const classes = useStyles()
    
    return (
        <div className={classes.container}>
            <h2 className={classes.name}>{challenge.name}</h2><br/>
            <h5 className={classes.date}>{getChallengeDate(challenge.runWindow)}</h5>
            <h3 className={classes.stage}>{t(challenge.stage)}</h3>
        </div>
    )
} 


const useStyles = makeStyles(muiTheme => ({
    container: {
        margin: '1rem 0',
    },
    name: {
        color: muiTheme.palette.primary.contrastText,
        padding: '1rem 5rem 1rem 1.5rem',
        fontSize: '1.15rem',
        fontWeight: 500,
        background: `url(${require('../../assets/icons/primary_rect.svg')})`,
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        backgroundPositionX: 'right',
        backgroundSize: 'cover'
    },
    date: {
        color: muiTheme.palette.secondary.main,
        padding: '0.5rem 5rem 0.5rem 1.5rem',
        fontSize: '0.9rem',
        fontWeight: 500,
        background: `url(${require('../../assets/icons/challengeProtocolDateRect.svg')})`,
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        backgroundPositionX: 'right',
        backgroundSize: 'cover'
    },
    stage: {
        fontWeight: 500,
        fontSize: '1.25rem',
        marginLeft: '1.5rem',
        marginTop: '1rem'
    },
    
}))


export default ChallengeHeader